import { render, staticRenderFns } from "./Demension.vue?vue&type=template&id=1416f0d6&scoped=true&"
import script from "./Demension.vue?vue&type=script&lang=js&"
export * from "./Demension.vue?vue&type=script&lang=js&"
import style0 from "./Demension.vue?vue&type=style&index=0&id=1416f0d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1416f0d6",
  null
  
)

export default component.exports